module.exports = __webpack_public_path__ + "img/Saj.f2e5132f.jpg";